<div>
  <h2 mat-dialog-title class="text-center">Clock out</h2>
  <mat-divider class="yellow-divider"></mat-divider>
  <mat-dialog-content>
    <div class="select-mood-wrapper">
      <label>Select your mood for today's shift (optional)</label>
      <div class="mood-selection row">
        @for (mood of moods; track mood.value) {
          <div class="col mood-item"
              (click)="selectMood(mood.value)"
              [class.selected]="isMoodSelected(mood.value)">
              <img [src]="mood.icon" [alt]="mood.name" /><br/>
              <span>{{ mood.name }}</span>
          </div>
        }
      </div>
      </div>
      <p>Did you have a break during this shift?</p>
      <mat-radio-group [(ngModel)]="hasBreak" style="margin-right: 0">
        <mat-radio-button [value]="true">Yes </mat-radio-button>
        <mat-radio-button [value]="false">No </mat-radio-button>
      </mat-radio-group>

      <div>
        <p>Note (optional)</p>
        <textarea [(ngModel)]="note" rows="4"> </textarea>
      </div>

      @if (data.webcamImage) {
        <div>
          <br />
          <label>Preview</label>
          <img [src]="data.webcamImage" class="preview-selfie" />
        </div>
      }
    </mat-dialog-content>

    <mat-dialog-actions align="center">
      <button
        mat-flat-button
        mat-dialog-close
        (click)="onHandleCloseDialog()"
        style="margin-right: 10px"
        class="btn-blue"
        >
        SUBMIT
      </button>
      <button
        mat-flat-button
        mat-dialog-close
        (click)="this.dialogRef.close(false)"
        class="btn-grey"
        >
        CANCEL
      </button>
    </mat-dialog-actions>
  </div>
